export default __webpack_public_path__ + "static/media/gallery_15.6e38b5df.jpg";